export default "__VITE_ASSET__f$eU95oy__"